module.exports = __webpack_public_path__ + "static/testione-c6b2c71646af07605ca0d978919bf63d.png";